import { render, staticRenderFns } from "./GiftDetail.vue?vue&type=template&id=fca6f252&scoped=true&"
import script from "./GiftDetail.vue?vue&type=script&lang=js&"
export * from "./GiftDetail.vue?vue&type=script&lang=js&"
import style0 from "./GiftDetail.vue?vue&type=style&index=0&id=fca6f252&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca6f252",
  null
  
)

export default component.exports